import startCase from 'lodash/startCase';
import dynamic from 'next/dynamic';
import Link from 'next/link';
import React, { useContext } from 'react';
import BreadCrumb from '../../components/breadcrumb/BreadCrumb';
import FeaturedSubcatsContainer from '../../components/category/FeaturedSubcatsContainer';
import { isWowcherIE } from '../../helpers/pages';
import { getNearMeLocation } from '../../helpers/url';
import ThemeContext from '../../providers/ThemeProvider';
import { getServerSideEssentials } from '../../redux/actions/ssr';
import { wrapper } from '../../redux/store/store';

const Form404Block = dynamic(() =>
  import('../../components/errors/Form404Block'),
);

const redirectToDealPage = (url) => {
  if (typeof window !== 'undefined') {
    const formattedUrl = url.replace('near-me', '');
    window.location.href = `/near-me${formattedUrl}`;
  }
};
const nearMeUrl = (url) => {
  const formattedUrl = url.replace('near-me', '');

  return `/near-me${formattedUrl}`;
};

const NearMeLocation = ({ data, location }) => {
  const theme = useContext(ThemeContext);
  const nearmelocation = location.replace(`-`, ' ');

  const specifiedSubcats = [
    {
      imageUrl:
        'https://static.wowcher.co.uk/images/seo/subcategory/65-275859.jpg?1618390792807',
      linkText: 'Spas',
      url: `/near-me/beauty/spa/${location}`,
    },
    {
      imageUrl: 'https://static.wowcher.co.uk/binaries/activities2.jpg',
      linkText: 'Activities & Things To Do',
      url: `/near-me/activities-entertainment/${location}`,
    },
    {
      imageUrl: 'https://static.wowcher.co.uk/binaries/restaurants4.jpg',
      linkText: 'Restaurants',
      url: `/near-me/restaurants-food/${location}`,
    },
    {
      imageUrl:
        'https://static.wowcher.co.uk/images/seo/subcategory/410-275884.jpg',
      linkText: 'Afternoon Tea',
      url: `/near-me/restaurants-food/afternoon-tea/${location}`,
    },
    {
      imageUrl:
        'https://static.wowcher.co.uk/images/seo/subcategory/222-275861.jpg?1618431583600',
      linkText: 'Cinemas',
      url: `/near-me/activities-entertainment/cinema/${location}`,
    },
    {
      imageUrl:
        'https://static.wowcher.co.uk/images/seo/subcategory/62-275859.jpg?1618391394215',

      linkText: 'Massages',
      url: `/near-me/beauty/massage/${location}`,
    },
  ];

  if (isWowcherIE()) {
    return <Form404Block statusCode={404} />;
  }

  return (
    <>
      <div className="rel-container">
        <div className="container">
          <BreadCrumb />
          <div className="seo__content">
            <div className="hero-image" id="seo-hero-image" />
            <h1>{startCase(nearmelocation)}</h1>
            <p>
              Check out our deals and offers for things to do in{' '}
              <span>{startCase(nearmelocation)}!</span> From the best places to
              eat to thrilling activities for the whole family,{' '}
              <span>{startCase(nearmelocation)}</span> is a great place to spend
              the day or even a relaxing week and with these deals you can
              experience the best it has to offer!
            </p>
            <h2 className="subHeading">{`Best in ${startCase(
              nearmelocation,
            )}`}</h2>
            <FeaturedSubcatsContainer specifiedSubcats={specifiedSubcats} />
            {!data && <p>No data rendered</p>}
            <div className="row">
              {data?.map((category, cat) => (
                <div className="col-xs-12 col-sm-6 col-md-6" key={cat}>
                  <h4 className="toTitleCase">
                    {category.categoryName}
                    <ul className="nearme-subcategory">
                      {category.subCategoryData.map((subcategory, index) => (
                        <li key={`a-${index}`}>
                          <Link href={nearMeUrl(subcategory.url)}>
                            <a
                              onClick={() =>
                                redirectToDealPage(nearMeUrl(subcategory.url))
                              }
                              onKeyDown={() =>
                                redirectToDealPage(nearMeUrl(subcategory.url))
                              }
                              role="link"
                              tabIndex={0}
                            >
                              {subcategory.nearMeSubCategoryText}
                            </a>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </h4>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .row {
          margin-top: 20px;
        }
        .rel-container {
          position: relative;
          font-family: 'Open Sans', sans-serif;
        }
        .container {
          margin-top: 0;
        }
        .nearme-subcategory {
          margin-top: 10px;
        }
        .toTitleCase,
        .subHeading {
          text-transform: capitalize;
          color: ${theme.colors.primary};
        }
        a {
          color: black !important;
          text-decoration: none;
        }
        ul li::marker {
          color: black;
        }
        @media (min-width: ${theme.breakpoints.smUp}) {
          .container {
            margin-top: 20px;
            margin-bottom: 20px;
          }
        }
        .seo__content {
          padding: 10px;
          background-color: ${theme.commoncolors.white};
          background-image: url(${theme.images.dealsplat});
          background-repeat: no-repeat;
          background-position: right -45px top -45px;
          background-size: 125px 125px;
          border-radius: 0;
          margin-bottom: 0;
          margin-left: -15px;
          margin-right: -15px;
          margin-top: 20px;
        }
        @media (min-width: ${theme.breakpoints.smUp}) {
          .seo__content {
            padding: 10px 30px;
            box-shadow: ${theme.boxshadow};
            border-radius: 6px;
            margin-bottom: 24px;
            margin-left: 0;
            margin-right: 0;
          }
        }

        .seo__content :global(h1) {
          color: ${theme.colors.primaryonwhite};
          font-size: 22px;
          text-align: left;
          line-height: 44px;
          font-weight: bold;
        }
        @media (min-width: ${theme.breakpoints.smUp}) {
          .seo__content :global(h1) {
            font-size: 26px;
            line-height: 64px;
          }
        }

        .seo__content :global(.hero-image) {
          background-size: cover;
          background-position: center;
          margin-top: 0;
          height: 180px;
          position: absolute;
          width: 100%;
          top: 0;
          left: 0;
          z-index: -1;
        }
        @media (min-width: ${theme.breakpoints.smUp}) {
          .seo__content :global(.hero-image) {
            margin-top: -20px;
            height: 370px;
          }
        }

        .seo__content :global(h4) {
          color: ${theme.colors.primaryonwhite};
          font-weight: bold;
          font-size: 20px;
          line-height: 24px;
        }

        .nearme-subcategory {
          list-style: none;
          padding-left: 0;
        }

        .nearme-subcategory a {
          color: #212529;
          cursor: pointer;
          display: block;
          font-size: 16px;
          padding-bottom: 8px;
        }

        /* Mobile Image - 736px x 414px */
        .hero-image {
          background-image: url(https://static.wowcher.co.uk/binaries/seo-lp-guides-shero.jpg);
        }
        /* Large Image - 1440px x 500px */
        @media (min-width: 767px) {
          .hero-image {
            background-image: url(https://static.wowcher.co.uk/binaries/seo-lp-guides-lhero.jpg);
          }
        }
      `}</style>
    </>
  );
};
export const getServerSideProps = wrapper.getServerSideProps(
  async (context) => {
    const { req, store, query } = context;
    await store.dispatch(getServerSideEssentials(req.url)).catch((error) => {
      console.log(`getServerSideEssentials error: ${error}`);
    });

    return getNearMeLocation(context);
  },
);

export default NearMeLocation;
